import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="6 5 13 14" {...props}>
    <path d="M8 5.14v14l11-7-11-7Z" />
  </svg>
)
export default SvgPlay
